import * as React from 'react'
import Shop from './Shop'
import Store from './Store'
import Actions from './Actions'
import { SCREEN } from './Srnka'

const TABS = {
	FOOD: 'FOOD',
	THINGS: 'THINGS'
}

export default class Market extends React.PureComponent {
	state = {
		currentTab: TABS.FOOD
	}

	onTabClick = tab => e => {
		e.preventDefault()
		this.setState({ currentTab: tab })
	}

	render() {
		return (
			<div className="Market">
				<div className="Tabs">
					<button
						className={`Tabs-tab ${
							this.state.currentTab === TABS.FOOD
								? 'Tabs-activeTab'
								: ''
						}`}
						onClick={this.onTabClick(TABS.FOOD)}
					>
						Jídlo
					</button>
					<button
						className={`Tabs-tab ${
							this.state.currentTab === TABS.THINGS
								? 'Tabs-activeTab'
								: ''
						}`}
						onClick={this.onTabClick(TABS.THINGS)}
					>
						Vybavení
					</button>
				</div>

				{this.state.currentTab === TABS.FOOD && (
					<Shop srnka={this.props.data} />
				)}
				{this.state.currentTab === TABS.THINGS && (
					<Store srnka={this.props.data} />
				)}

				{/* <Actions srnka={this.props.data} /> */}

				<button
					className="LeftIconButton LeftIconButton-black"
					onClick={e => {
						e.preventDefault()
						this.props.changeScreen(SCREEN.FIELD)
					}}
				>
					<i className="fa fa-tree" aria-hidden="true" />
				</button>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Market.js